import http from 'lib/http'; // 获取单位课程列表请求配置

export var urlGetSchoolCourseListBySchoolId = '/XOrg/SchoolCourseManager/getSchoolCourseListBySchoolId';
export var urlgetschooCourseListByCourse = '/XOrg/SchoolCourseManager/getschooCourseListByCourse';
export var urlAddSchoolCourse = '/XOrg/MajorSchoolCourseManager/addSchoolCourse';
export var urlImportSchoolCourse = '/XOrg/MajorSchoolCourseManager/importSchoolCourse';
export var urlEditSchoolCourse = '/XOrg/MajorSchoolCourseManager/editSchoolCourse';
export var urlDeleteSchoolCourse = '/XOrg/MajorSchoolCourseManager/deleteSchoolCourse';
export var urldeleteByteaId = '/XOrg/SchoolCourseManager/deleteByteaId';
export var urlupdateById = '/XOrg/SchoolCourseManager/updateById'; // wt 2019年1月19日 15:44:28 单位课程关联专业

export var urlgetMajorList = '/XOrg/MajorSchoolCourseManager/getMajorList';
export var urladdMajor = '/XOrg/MajorSchoolCourseManager/addMajor';
export var urlgetSchoolCourseJoinMajorList = '/XOrg/MajorSchoolCourseManager/getSchoolCourseJoinMajorList'; // 专业课程

export var urlGetSchoolCourseListByMajoyId = '/XOrg/MajorSchoolCourseManager/getSchoolCourseListByMajoyId'; // 获取课程列表

export function getschooCourseListByCourse() {
  return http.post(urlgetschooCourseListByCourse, {});
} // 获取课程列表

export function getSchoolCourseList(SchoolType, MajorId, page, Code, Title, pageType) {
  return http.post(urlGetSchoolCourseListBySchoolId, {
    SchoolType: SchoolType,
    MajorId: MajorId,
    page: page,
    Code: Code,
    Title: Title,
    pageType: pageType
  });
} // 获取专业课程列表

export function getSchoolCourseListByMajor(SchoolType, majoyId, majoyName, schoolCourseCode, title, page, notset, pageSize, pageType) {
  return http.post(urlGetSchoolCourseListByMajoyId, {
    SchoolType: SchoolType,
    majoyId: majoyId,
    majoyName: majoyName,
    schoolCourseCode: schoolCourseCode,
    title: title,
    page: page,
    notset: notset,
    pageType: pageType,
    pageSize: pageSize
  });
} // 添加单位课程列表

export function addSchoolCourse(MajoyId, title, schoolcoursecode, description, cover, SchoolType, majorIds) {
  return http.post(urlAddSchoolCourse, {
    MajoyId: MajoyId,
    title: title,
    schoolcoursecode: schoolcoursecode,
    description: description,
    cover: cover,
    SchoolType: SchoolType,
    majorIds: majorIds
  });
} // 引入课程

export function importSchoolCourse(majoyId, ids) {
  return http.post(urlImportSchoolCourse, {
    majoyId: majoyId,
    ids: ids
  });
} // 修改单位课程列表

export function editSchoolCourse(schoolCourseId, title, code, description, docJson, majorIds, schoolType) {
  return http.post(urlEditSchoolCourse, {
    schoolCourseId: schoolCourseId,
    title: title,
    code: code,
    description: description,
    docJson: docJson,
    majorIds: majorIds,
    schoolType: schoolType
  });
} // 删除单位课程列表

export function deleteSchoolCourse(ids) {
  return http.post(urlDeleteSchoolCourse, {
    ids: ids
  });
} // 删除单位课程列表

export function deleteByteaId(id) {
  return http.post(urldeleteByteaId, {
    id: id
  });
} // 获取单位的专业列表

export function getMajorList() {
  return http.post(urlgetMajorList, {});
} // 单位课程添加专业标签

export function addMajor(majorIds, schoolCourseId, schoolType) {
  return http.post(urlupdateById, {
    majorIds: majorIds,
    schoolCourseId: schoolCourseId,
    schoolType: schoolType
  });
} // 获取单位课程关联的专业列表

export function getSchoolCourseJoinMajorList(schoolCourse) {
  return http.post(urlgetSchoolCourseJoinMajorList, {
    schoolCourse: schoolCourse
  });
}